/* global angular */

var modal = require('angular-ui-bootstrap/src/modal')
require('./modal-callme.css')
require('./gem-modal.css')
require('aem-libs-uniforms-angularjs/src/components/uniform-callme/uniform-callme.component.js')

angular.module('ModalCallmeCmp', [modal, 'UniformCallmeCmp'])
  .service('ModalCallmeService', fn)

fn.$inject = ['$uibModal', '$templateCache', 'userTracking']
function fn ($modal, $templateCache, userTracking) {
  $templateCache.put('myWindowModal.html', require('./window.tpl.html'))

  var modalDefaults = {
    backdrop: true,
    keyboard: true,
    modalFade: true,
    placement: 'bottom',
    windowTemplateUrl: 'myWindowModal.html',
    template: require('./modal-callme.tpl.html')
  }

  var modalOptions = {
    closeButtonText: 'Zavřít'
  }

  this.show = function (customModalDefaults, customModalOptions) {
    var defaults = {}
    var options = {}

    angular.extend(defaults, modalDefaults, customModalDefaults)
    angular.extend(options, modalOptions, customModalOptions)

    if (!defaults.controller) {
      defaults.controller = defaultModalController(defaults, options, userTracking)
    }
    return $modal.open(defaults).result
  }

  this.validateAndMapGrid = function (grid) {
    if (grid === 'default') {
      grid = 3 // is 12of12
    }

    if (grid !== 1 && grid !== 2 && grid !== 3) {
      grid = 3
    }

    var cssClassName = 'md-' + (grid * 4) + 'of12'

    return cssClassName
  }

  this.showForm = function (formId, design, showTitle, userTrackingParams, grid) {
    design = design || ''
    showTitle = showTitle !== false
    userTrackingParams = userTrackingParams || null
    grid = grid || 'default'
    var gridCssClass = this.validateAndMapGrid(grid)
    var options = { formId: formId, design: design, showTitle: showTitle, userTrackingParams: userTrackingParams, grid: gridCssClass }
    return this.show({}, options)
  }

  this.showFeedbackForm = function (formId, design, showTitle, userTrackingParams, grid, initValue) {
    design = design || ''
    showTitle = showTitle !== false
    userTrackingParams = userTrackingParams || null
    grid = grid || 'default'
    var gridCssClass = this.validateAndMapGrid(grid)
    var options = { formId: formId, design: design, showTitle: showTitle, userTrackingParams: userTrackingParams, grid: gridCssClass, initValue: initValue }
    return this.show({}, options)
  }

  this.onUniformSubmitted = function (params) {
    this.close()
  }
}

function defaultModalController (defaults, options, userTracking) {
  function controller ($scope, $modalInstance) {
    $scope.modalOptions = options
    $scope.modalOptions.ok = function (result) {
      $modalInstance.close(result)
    }
    $scope.modalOptions.close = $scope.modalOptions.close || function () {
      userTracking.onModalClose()
      $modalInstance.dismiss('cancel')
    }
  }
  controller.$inject = ['$scope', '$uibModalInstance']
  return controller
}
